import script from "./AccountTypeTab.vue?vue&type=script&lang=ts&setup=true"
export * from "./AccountTypeTab.vue?vue&type=script&lang=ts&setup=true"

import "./AccountTypeTab.vue?vue&type=style&index=0&id=ee9a1c10&scoped=true&lang=scss"

import exportComponent from "/builds/gh_prod_devops/gh_prod_devops_web/webtrade_prod_deploy/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ee9a1c10"]])

export default __exports__